import client from './client';

// Scheduling = resource allocations (bookings) + the aggregated calendar payload
// and utilisation reporting. Team-scoped like physicalResources: `team` rides in
// the query on reads and the body on writes. The surfacing endpoints
// (taskAllocations / customerAllocations / myAllocations) reuse their host
// route's own auth and therefore take no `team`.
export const schedulingApi = {
  // ── Aggregated calendar payload + axis ──────────────────────────────────
  async getSchedule(params = {}) {
    const { data } = await client.get('/api/schedule', { params });
    return data;
  },

  async getResources(params = {}) {
    const { data } = await client.get('/api/schedule/resources', { params });
    return data;
  },

  async getUtilisation(params = {}) {
    const { data } = await client.get('/api/schedule/utilisation', { params });
    return data;
  },

  // ── Allocation CRUD ─────────────────────────────────────────────────────
  async listAllocations(params = {}) {
    const { data } = await client.get('/api/resource-allocations', { params });
    return data;
  },

  async getAllocation(id, team) {
    const { data } = await client.get(`/api/resource-allocations/${id}`, {
      params: { team },
    });
    return data;
  },

  async createAllocation(allocationData) {
    const { data } = await client.post('/api/resource-allocations', allocationData);
    return data;
  },

  async updateAllocation(id, allocationData) {
    const { data } = await client.patch(`/api/resource-allocations/${id}`, allocationData);
    return data;
  },

  async cancelAllocation(id, team) {
    const { data } = await client.post(`/api/resource-allocations/${id}/cancel`, { team });
    return data;
  },

  async deleteAllocation(id, team) {
    const { data } = await client.delete(`/api/resource-allocations/${id}`, {
      params: { team },
    });
    return data;
  },

  // ── Read-only surfacing on existing entities ────────────────────────────
  async taskAllocations(key) {
    const { data } = await client.get(`/api/tasks/${key}/allocations`);
    return data;
  },

  async customerAllocations(id) {
    const { data } = await client.get(`/api/customers/${id}/allocations`);
    return data;
  },

  async myAllocations() {
    const { data } = await client.get('/api/profile/allocations');
    return data;
  },
};
